import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';

import * as fileSaver from 'file-saver';
import { ConfigServerService, CustomHttp } from '../../../../core';
import { PedidoFilter } from '../../filter';
import { PedidoExcelListagemOptions } from '../listagem/pedido-excel-listagem-options';

@Injectable({
    providedIn: 'root'
})
export class PedidoExcelHttpService {
    private path: string;


    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.path = `${configServerService.getPathApiExcel()}/pedido`;
    }

    /** Realiza a exportação da listagem dos pedidos para Excel */
    exportListagem(nomeExportacao: string, filter: PedidoFilter, orderBy: number, orderByDir: string, options: PedidoExcelListagemOptions): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            // Params
            let params = new HttpParams()
                                .append('nomeExportacao', nomeExportacao ?? '')
                                .append('orderBy', orderBy.toString())
                                .append('orderByDir', orderByDir ? orderByDir : '');
            // Filter params
            if (filter) {
                params = filter.createParams(params);
            }
            // Options
            if (options) {
                params = options.createParams(params);
            }

             this.customHttp.get<Blob>(`${this.path}/listagem`, {params, responseType: 'blob'})
                .subscribe(
                    excel => {
                        nomeExportacao = nomeExportacao.replace('.xlsx', '');
                        fileSaver.saveAs(excel, `${nomeExportacao}.xlsx`);
                        resolve();
                    },
                    error => {
                        reject(error);
                    }
                );
        });
    }
}
